// removed by extract-text-webpack-plugin
module.exports = {"headingLink":"_3hF5QPd","heading":"_26ir1x3","noItems_highlight":"_3-dlDOR","icon":"sMaJMus","iconSvg":"_2boW5fM","items":"yX4lfZ5","noItems":"_2Z-tKB1","viewAll":"_3o5o3Rf","chevron":"eSv-RXP","chevronSvg":"_19kOfwg"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/HomePage/components/Dashboard/components/SignedInDashboard/components/SavedJobsDashboard/SavedJobsDashboard.less
 ** module id = 773
 ** module chunks = 0
 **/